import Image from "next/image";
import SingleComment from "./singleComment";
import AddComment from "./addComment";
import { useAppSelector } from "redux-share/hooks";
import { IComments, ConditionName, IUsersCommentsProfiles, zIndex, ICommentContentPopoverProps } from "interfaces";
import IMAGES from "../../../../../images/importImages";
import { conditions } from "helpers";
import { handleCommentsIdsInLocalStorage } from "redux-share/actions/comment.action";
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const TouchScreenCommentObserver = dynamic(() => import("./touchScreenCommentObserver"));

const CommentContentPopover = ({ setScrollEnd }: ICommentContentPopoverProps) => {

    const { replyToAuthor, comments, usersCommentsProfiles } = useAppSelector(({ comments: { replyToAuthor, comments, usersCommentsProfiles } }) => ({ replyToAuthor, comments, usersCommentsProfiles }), shallowEqual);

    return (
        <>
            {comments.length ? (
                <div className="pl-mb-[80px]">
                    <div className="pl-px-4 pl-flex pl-flex-col pl-gap-2 pl-relative" style={{ zIndex: zIndex.comments }}>
                        {comments.map((comment: IComments) => <SingleComment key={comment.id} comment={comment} user={usersCommentsProfiles.find((profile: IUsersCommentsProfiles) => profile.id === comment.author)} commentsLocalStorageIds={handleCommentsIdsInLocalStorage()} />)}
                        <TouchScreenCommentObserver setScrollEnd={setScrollEnd} />
                    </div>
                </div>
            ) : (
                <div className="pl-w-full pl-h-full pl-flex pl-flex-col pl-justify-center pl-items-center pl-gap-[6px] pl-pb-[80px]">
                    <Image src={conditions(ConditionName.isDarkMode) ? IMAGES.commentEmptyStateBlack : IMAGES.commentEmptyStateWhite} width={216} height={98.48} />
                    <p>در حال حاضر هیچ دیدگاهی وجود ندارد.</p>
                </div>
            )}

            <AddComment type={replyToAuthor.id ? "reply" : "comment"} />
        </>
    )
}

export default CommentContentPopover;